import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, InputGroup, InputGroupText, FormText, Col, Row, CustomInput, Button } from "reactstrap";
import { useService } from "../../context/ServiceContext";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { fireAlert } from "../../utils/alerts";

function NotaCertLookup({ id, history }) {
  const [idNotaCert, setIdNotaCert] = useState(id || "");
  const [searchId, setSearchId] = useState("");

  const [name, setName] = useState("");
  const [notes, setNotes] = useState("");
  const [code, setCode] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { certificateIdNotaCertProvider, certificateNotaCertStore } = useService();
  const intl = useIntl();

  useEffect(() => {
    async function getData() {
      setLoading(true);
      try {
        const data = await certificateIdNotaCertProvider.get(idNotaCert);

        setName(data.descripcion || "");
        setNotes(data.notas || "");
        setCode(data.notaCert || "");
        setActive(!!data.activo);
      } catch (error) {
        console.error("Error loading NotaCert:", error);
      } finally {
        setLoading(false);
      }
    }

    if (idNotaCert) getData();
  }, [idNotaCert]);

  const handleSearch = () => {
    const trimmedId = searchId.trim();

    if (!trimmedId) {
      return;
    }

    setLoading(true);
    setError("");

    history.push(`/certificates/link_nota_cert/${trimmedId}`);
    setIdNotaCert(trimmedId);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  async function update() {
    try {
      var data = {
        idNotaCert,
        description: name,
        notes,
        notaCert: code,
        active,
      };
      await certificateNotaCertStore.store(data);
      fireAlert(
        <>
          <p>{intl.formatMessage({ id: "certificates.successfully_saved_nota_cert", defaultMessage: "Successfully saved certificate notes" })}</p>
        </>,
        intl.formatMessage({ id: "app.success", defaultMessage: "Success" }),
        "success"
      ).then(() => {
        //history.push(`/certificates`);
      });
    } catch (error) {
      fireAlert("Something went wrong", intl.formatMessage({ id: "app.error", defaultMessage: "Error" }), "error");
    }
  }

  function back() {
    setIdNotaCert("");
    setName("");
    setNotes("");
    setCode("");
    history.push("/certificates/link_nota_cert");
  }

  if (!idNotaCert) {
    return (
      <Row>
        <Col md="6">
          <FormGroup>
            <Label for="idNotaCert">
              <FormattedMessage id="certificates.nota_cert_lookup_title" defaultMessage="idNotaCert" />
            </Label>
            <Input id="searchId" type="text" value={searchId} onChange={(e) => setSearchId(e.target.value)} onKeyPress={handleKeyPress} disabled={loading} />
            <Button color="primary" className="mt-2" onClick={handleSearch} disabled={loading}>
              {intl.formatMessage({ id: "app.search", defaultMessage: "Search" })}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col md="8">
          <FormGroup>
            <Label for="name">
              <FormattedMessage id="certificates.certificate_name" defaultMessage="CERT Name" />
            </Label>
            <Input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} disabled={loading} />
          </FormGroup>

          <FormGroup>
            <Label for="code">
              <FormattedMessage id="certificates.certificate_code" defaultMessage="CERT Code" />
            </Label>
            <Input id="code" type="text" value={code} onChange={(e) => setCode(e.target.value)} disabled={loading} />
          </FormGroup>

          <FormGroup>
            <Label for="notes">
              <FormattedMessage id="certificates.certificate_notes" defaultMessage="Notes" />
            </Label>
            <Input id="notes" type="textarea" rows="3" value={notes} onChange={(e) => setNotes(e.target.value)} disabled={loading} />
          </FormGroup>

          <FormGroup>
            <Label>
              <FormattedMessage id="attribute.active" defaultMessage="Active" />
            </Label>
            <CustomInput
              type="switch"
              id={"active"}
              checked={active}
              onChange={(e) => {
                setActive(e.target.checked);
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <button type="button" className="btn btn-outline-danger" onClick={update}>
            <FormattedMessage id="app.update" defaultMessage="Update" />
          </button>

          <button type="button" className="btn btn-outline-dark" onClick={back}>
            <FormattedMessage id="app.back" defaultMessage="Cancel" />
          </button>
        </Col>
      </Row>
    </>
  );
}

export default NotaCertLookup;
